import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 25000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Refresh-on-401: keep the session alive across app background/relaunch.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true })
            .finally(() => {
              /* reset after settle below */
            });
        }
        const { data } = await refreshing;
        refreshing = null;
        if (data?.token) {
          localStorage.setItem("token", data.token);
          original.headers.Authorization = `Bearer ${data.token}`;
        }
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("token");
        throw error;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail, error) {
  if (error && !error.response) {
    if (error.code === "ECONNABORTED" || /timeout/i.test(error.message || "")) return "Connessione lenta: il server non ha risposto in tempo. Controlla la rete e riprova.";
    return "Nessuna connessione: controlla la rete e riprova.";
  }
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
